function Aria() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>An ARIA role, state, or property is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>ARIA provides enhanced semantics and accessibility for web content.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the ARIA role, state, or property is used correctly. Use standard HTML accessibility features when possible. Be aware that support for ARIA is limited in older browsers and assistive technologies.</p>
    </blockquote>
  )
}

export default Aria